const NavbarDefault = require('./NavbarDefault')

module.exports = NavbarDefault